import React, { useEffect, useState } from 'react';
import { model } from '@whizz/api-client';
import { Loader } from '../../components';

interface Props {
  studentId: number;
  /**
   * Controls whether password should be fetched. Defaults to true.
   */
  fetch?: boolean;
}

// TODO: state of passwords to avoid a call everytime it renders
const StudentsPassword = ({ studentId, fetch = true }: Props): JSX.Element => {
  const [ loading, setLoading ] = useState(true);
  const [ password, setPassword ] = useState('');

  useEffect( () => {
    if (fetch) {
      setLoading(true);
      new model.Student({
        id: studentId,
      }).getStudentPassword()
        .then((pass) => setPassword(pass))
        .catch((err) => console.log('Error getting password', err))
        .finally(() => setLoading(false));
    }
  }, [ studentId, fetch ]);

  return (
    loading
      ? <Loader disableLabel={true} style={{ display: 'inline-block' }}/>
      : <>{password}</>
  );
};

export default StudentsPassword;
